// import React, { useState } from "react";
// import "./Auth.css";

// const Auth = ({ onAuthSuccess }) => {
//   const [isRegister, setIsRegister] = useState(false);

//   return (
//     <div className="auth-container">
//       {/* 🔥 ACTIVE CLASS MOVED HERE */}
//       <div className={`container ${isRegister ? "active" : ""}`}>

//         {/* LOGIN */}
//         <div className="form-box login">
//           <form
//             onSubmit={(e) => {
//               e.preventDefault();
//               onAuthSuccess();
//             }}
//           >
//             <h1>Login</h1>

//             <div className="input-box">
//               <input type="text" placeholder="Username" required />
//               <i className="bx bxs-user"></i>
//             </div>

//             <div className="input-box">
//               <input type="password" placeholder="Password" required />
//               <i className="bx bxs-lock-alt"></i>
//             </div>

//             <button className="btn">Login</button>
//           </form>
//         </div>

//         {/* REGISTER */}
//         <div className="form-box register">
//           <form
//             onSubmit={(e) => {
//               e.preventDefault();
//               onAuthSuccess();
//             }}
//           >
//             <h1>Register</h1>

//             <div className="input-box">
//               <input type="text" placeholder="Username" required />
//               <i className="bx bxs-user"></i>
//             </div>

//             <div className="input-box">
//               <input type="email" placeholder="Email" required />
//               <i className="bx bxs-envelope"></i>
//             </div>

//             <div className="input-box">
//               <input type="password" placeholder="Password" required />
//               <i className="bx bxs-lock-alt"></i>
//             </div>

//             <button className="btn">Register</button>
//           </form>
//         </div>

//         {/* TOGGLE PANELS */}
//         <div className="toggle-box">
//           <div className="toggle-panel toggle-left">
//             <h1>Hello, Welcome!</h1>
//             <p>Don't have an account?</p>
//             <button className="btn" onClick={() => setIsRegister(true)}>
//               Register
//             </button>
//           </div>

//           <div className="toggle-panel toggle-right">
//             <h1>Welcome Back!</h1>
//             <p>Already have an account?</p>
//             <button className="btn" onClick={() => setIsRegister(false)}>
//               Login
//             </button>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default Auth;


import React, { useState } from "react";
import "./Auth.css";
import { API_BASE_URL } from "../utils/api";

const Auth = ({ onAuthSuccess }) => {
  const [isRegister, setIsRegister] = useState(false);

  // form state
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // REGISTER
  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE_URL}/auth/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, email, password }),
      });

      const data = await res.json();

      if (!res.ok) throw new Error(data.message);

      alert("Registration successful! Please login.");
      setIsRegister(false);
      setUsername("");
      setEmail("");
      setPassword("");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // LOGIN
  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE_URL}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (!res.ok) throw new Error(data.message);

      // Save token
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));

      onAuthSuccess();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className={`container ${isRegister ? "active" : ""}`}>

        {/* LOGIN */}
        <div className="form-box login">
          <form onSubmit={handleLogin}>
            <h1>Login</h1>

            {error && <p style={{ color: "red" }}>{error}</p>}

            <div className="input-box">
              <input
                type="email"
                placeholder="Email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <i className="bx bxs-user"></i>
            </div>

            <div className="input-box">
              <input
                type="password"
                placeholder="Password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <i className="bx bxs-lock-alt"></i>
            </div>

            <button className="btn" disabled={loading}>
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>
        </div>

        {/* REGISTER */}
        <div className="form-box register">
          <form onSubmit={handleRegister}>
            <h1>Register</h1>

            {error && <p style={{ color: "red" }}>{error}</p>}

            <div className="input-box">
              <input
                type="text"
                placeholder="Username"
                required
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
              <i className="bx bxs-user"></i>
            </div>

            <div className="input-box">
              <input
                type="email"
                placeholder="Email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <i className="bx bxs-envelope"></i>
            </div>

            <div className="input-box">
              <input
                type="password"
                placeholder="Password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <i className="bx bxs-lock-alt"></i>
            </div>

            <button className="btn" disabled={loading}>
              {loading ? "Registering..." : "Register"}
            </button>
          </form>
        </div>

        {/* TOGGLE */}
        <div className="toggle-box">
          <div className="toggle-panel toggle-left">
            <h1>Hello, Welcome!</h1>
            <p>Don't have an account?</p>
            <button className="btn" onClick={() => setIsRegister(true)}>
              Register
            </button>
          </div>

          <div className="toggle-panel toggle-right">
            <h1>Welcome Back!</h1>
            <p>Already have an account?</p>
            <button className="btn" onClick={() => setIsRegister(false)}>
              Login
            </button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Auth;
